// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HWHGA","fullWidth":"styles_fullWidth__LE6rZ"};